import React from 'react';
import PropTypes from 'prop-types';
import { FaqAnswerCard, Spacer } from 'components';
import styled from '@emotion/styled';

import * as MediaQueries from 'utils/MediaQueries';

const FaqCategoryHeader = styled.div({
    backgroundColor: 'var(--color-containersecondary)',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',

    '> div': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 'var(--space-2xsmall)',

        h3: { marginBottom: 'var(--space-2xtiny)' },

        [MediaQueries.TabletOrLarger]: {
            padding: 'var(--space-xsmall) var(--space-xsmall) var(--space-small)',
        },

        [MediaQueries.DesktopOrLarger]: {
            maxWidth: 'var(--breakpoint-desktop)',
            h3: { marginBottom: 'var(--space-micro)' },
        },
    },
});

// const FaqCategoryHeader = styled.div`
//     background-color: var(--color-containersecondary);
//     display: flex;
//     justify-content: center;
//     width: 100%;

//     > div {
//         width: 100%;
//         display: flex;
//         flex-direction: column;
//         padding: var(--space-2xsmall);

//         h3 {
//             margin-bottom: var(--space-2xtiny);
//         }

//         ${MediaQueries.TabletOrLarger} {
//             padding: var(--space-xsmall) var(--space-xsmall) var(--space-small);
//         }

//         ${MediaQueries.DesktopOrLarger} {
//             max-width: var(--breakpoint-desktop);

//             h3 {
//                 margin-bottom: var(--space-micro);
//             }
//         }
//     }
// `;

const FaqAnswers = ({ categoriesAndEntries }) => (
    <>
        { categoriesAndEntries.map(category => (
            <React.Fragment key={ category.name }>
                <FaqCategoryHeader>
                    <div>
                        <h3>{ category.name }</h3>
                    </div>
                </FaqCategoryHeader>
                <article className="faqCategoryAnswers" key={ category.name }>
                    <section>
                        { category.entries.map(entry => (
                            <FaqAnswerCard key={ entry.id } { ...entry }/>
                        )) }
                    </section>
                    <Spacer />
                </article>
            </React.Fragment>
        )) }
    </>
);

FaqAnswers.defaultProps = {};

FaqAnswers.propTypes = {
    categoriesAndEntries: PropTypes.array,
};

export default FaqAnswers;
